export const getColumnWidth = (data: any[], headerNames: string[]) => {
  const columnWidths = Array.from(
    { length: Object.keys(data[0]).length },
    (_, i) => headerNames[i].length + 1
  )
  data.forEach((d) => {
    let i = 0
    for (const [value] of Object.entries(d)) {
      const valueLength = value ? (value as any).toString().length + 1 : 0
      columnWidths[i] =
        valueLength > columnWidths[i] ? valueLength : columnWidths[i]
      i++
    }
  })
  return columnWidths
}
